<style lang="scss" scoped>
  .main-layout {
    main {
      position: relative;

      &.about {
        margin-bottom: 60px;

        @include media(max, md) {
          margin-bottom: 30px;
        }
      }
    }
  }
</style>

<template>
  <div class="main-layout">
    <main>
      <slot/>
    </main>
  </div>
</template>

<script>


export default {
  name: 'MainLayout',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>
